Formatting = {

    shortName: function(o) {
        if (o.userName)
            return o.userName;
        else if (o.fullName)
            return o.fullName;
        else
            return o.emailAddress;
    },

    longName: function(o) {
        if (o.fullName)
            return o.fullName;
        else if (o.userName)
            return o.userName;
        else
            return o.emailAddress;
    },

    date: function(date, ref, withSeconds) {
        if (!date)
            return null;
        if (typeof ref == 'undefined') ref = new Date();
        if (typeof ref == 'number') ref = new Date(ref);
        if (typeof date == 'number') date = new Date(date);

        var format = 'yyyy-MM-dd HH:mm' + (withSeconds ? ':ss' : '');
        var dateStr = date.toString(format);
        var refStr = ref ? ref.toString(format) : '';
        if (dateStr.substring(0,11) == refStr.substring(0,11))
            return dateStr.substring(11);
        else if (dateStr.substring(0,5) == refStr.substring(0,5))
            return dateStr.substring(5);
        return dateStr;
    },

    time: function(date, withSeconds) {
        if (!date)
            return null;
        if (typeof date == 'number') date = new Date(date);
        var format = 'HH:mm' + (withSeconds ? ':ss' : '');
        return date.toString(format);
    },

    datePart: function(date, ref, tz) {
        if (typeof date == 'undefined')
            return;
        if (date == null)
            return null;
        if (typeof ref == 'undefined') ref = new Date();
        if (typeof ref == 'number') ref = new Date(ref);
        if (typeof date == 'number') date = new Date(date);

        var dateStr = tz && tz.length > 8 ? date.toLocaleDateString("sv-SE",{timeZone: tz}) : date.toString('yyyy-MM-dd');
        var refStr = ref ? ref.toString('yyyy-MM-dd') : '';
        if (dateStr.substring(0,5) == refStr.substring(0,5))
            return dateStr.substring(5);
        return dateStr;
    },

    duration : function(minutes) {
        minutes = Math.round(minutes);
        var sign = 1;
        if (minutes < 0) {
            minutes = -minutes;
            sign = -1;
        }
        if (minutes >= 60) {
            if (minutes % 60 == 0) {
                return sign*minutes/60;
            } else if (minutes % 30 == 0) {
                return sign*Math.round(minutes*10/60)/10;
            } else {
                var hour = Math.floor(minutes / 60).toString();
                var minute = Math.floor(minutes - hour * 60).toString();
                if (minute.length == 1) minute = "0" + minute;
                return sign*hour + ":" + minute;
            }
        } else if (minutes == 0)
            return "0";
        else
            return (sign < 0 ? "-" : "") + "0:" + (minutes < 10 ? "0" : "") + minutes;
    },

    durationSec : function(seconds) {
        seconds = Math.round(seconds);
        var sign = "";
        if (seconds < 0) {
            seconds = -seconds;
            sign = "-";
        }

        var hours = Math.floor(seconds / 60 / 60);
        var minutes = Math.floor(seconds / 60 - hours * 60);
        var second = Math.floor(seconds - hours * 60 * 60 - minutes * 60);
        if (hours > 0) {
            return sign + (hours < 10 ? "0" : "") + hours + ":" + (minutes < 10 ? "0" : "") + minutes + ":" + (seconds < 10 ? "0" : "") + second;
        } else if (minutes > 0) {
            return sign + "00:" + (minutes < 10 ? "0" : "") + minutes + ":" + (seconds < 10 ? "0" : "") + second;
        } else
            return sign + "00:00:" + (seconds < 10 ? "0" : "") + second;
        /*
        if (seconds >= 3600) {
            if (seconds % 3600 == 0) {
                return sign*seconds/3600;
            } else if (seconds % (1800) == 0) {
                return sign*Math.round(seconds*10/60/60)/10;
            } else {
                var hour = Math.floor(seconds / 60 / 60).toString();
                var minute = Math.floor(seconds - hour * 60 * 60).toString();
                var second = Math.floor(seconds - hour * 60 * 60 - minute * 60).toString();
                //if (minute.length == 1) minute = "0" + minute;
                return sign*hour + ":" + minute + ":" + second;
            }
        } else if (seconds > 60)
            return (sign < 0 ? "-" : "") + "0:" + minutes;
        else
            return "" + sign*minutes;//*/
    },

    durationMinutes : function(minutes) {
        if (isNaN(parseInt(minutes)))
            return undefined;
        minutes = Math.round(minutes);
        var sign = 1;
        if (minutes < 0) {
            minutes = -minutes;
            sign = -1;
        }

        if (minutes >= 60) {
            var hour = Math.floor(minutes / 60).toString();
            var minute = Math.floor(minutes - hour * 60).toString();
            if (minute.length == 1) minute = "0" + minute;
            return sign*hour + ":" + minute;
        } else
            return "" + sign*minutes;
    },

    parseDate: function(dateStr) {
        if (!dateStr || !dateStr.trim())
            return null;
        var a=dateStr.split(/\s+/);
        var d=a[0].split("-");
        // month-date (without year)
        if (d.length == 2 && d[0] <= 12)
            d.splice(0, 0, new Date().getYear()+1900);
        // two-digit year
        if (d[0] < 100)
            d[0] = "20" + d[0];

        if (a.length > 1) {
            var t=a[1].split(":");
            while (t.length < 3) t.push(0);
            return new Date(d[0],(d[1]-1),d[2],t[0],t[1],t[2]);
        } else {
            return new Date(d[0],(d[1]-1),d[2]);
        }
    },

    parseUTCDate: function(dateStr) {
        if (!dateStr || !dateStr.trim())
            return null;
        var a=dateStr.split(/\s+/);
        var d=a[0].split("-");
        // month-date (without year)
        if (d.length == 2 && d[0] <= 12)
            d.splice(0, 0, new Date().getYear()+1900);
        // two-digit year
        if (d[0] < 100)
            d[0] = "20" + d[0];

        if (a.length > 1) {
            var t=a[1].split(":");
            while (t.length < 3) t.push(0);
            return new Date(d[0],(d[1]-1),d[2],t[0],t[1],t[2]);
        } else {
            return new Date(d[0]+'-'+d[1]+'-'+d[2]);
        }
    },

    parseTime: function(timeStr, date) {
        if (!timeStr) return null;
        // Absolute date?
        if (timeStr.match(/^[\d-]+\s+[\d:]+$/))
            return Formatting.parseDate(timeStr);

        // Reformat the string (add colons etc lazy stuff)
        timeStr = timeStr.trim();
        var pm = timeStr.match(/[\d:\s]+pm?$/i);
        timeStr = timeStr.replace(/[^\d:]/g,'');
        if (timeStr.indexOf(':') < 0 && timeStr.length > 2) {
            timeStr = timeStr.substring(0,4);
            // add colon
            if (timeStr.length == 3)
                timeStr = '0' + timeStr;
            timeStr = timeStr.substring(0,timeStr.length-2) + ':' + timeStr.substring(timeStr.length-2);
        } else if (timeStr.length <= 2) {
            // pad zeroes if only hours written
            timeStr = timeStr + ':00';
        } else if (timeStr.length > 5) {
            timeStr = timeStr.replace(':','');
            timeStr = timeStr.substring(0,2) + ':' + timeStr.substring(2,4);
        }
        // Parse and convert to a date object
        if (!date)
            date = new Date();
        var d = new Date(date);
        var t = timeStr.split(":");
        var returnDate = null;
        if (t.length == 3) {
            returnDate = new Date(d.setHours(t[0],t[1],t[2],0));
        } else if (t.length == 2) {
            returnDate = new Date(d.setHours(t[0],t[1],0,0));
        } else if (t.length == 1 && !isNaN(parseInt(t[0]))) {
            returnDate = new Date(d.setHours(t[0],0,0,0));
        }

        if (pm && returnDate.getHours() <= 12)
            returnDate.setHours(returnDate.getHours()+12);

        return returnDate;
    },

    parseDuration: function(timeStr) {
        if (!timeStr) return null;
        if (typeof timeStr == 'string') timeStr = timeStr.replace(/,/,'.');
        if (timeStr.indexOf(':') >= 0) {
            var t = timeStr.split(":");
            var minutes = 0;
            if (t[0].length > 0)
                // if input in the format "-:30" set hours to 0 to avoid NaN - Andy
                if (t[0] == '-') {
                t[0] = 0;
                }
                minutes = parseInt(t[0])*60;
                // if time is negative minutes should be subtracted - Andy
                if (timeStr.indexOf('-') == 0) {
                    minutes -= parseInt(t[1]);
                } else {
                    minutes += parseInt(t[1]);
                }
            return minutes;
        }
        return Math.round(parseFloat(timeStr)*60);
    },

    parseDurationMinutes: function(timeStr) {
        if (!timeStr) return null;
        if (timeStr.indexOf(':') >= 0) {
            var t = timeStr.split(":");
            var minutes = 0;
            if (t[0].length > 0)
                minutes = parseInt(t[0])*60;
            minutes += parseInt(t[1]);
            return minutes;
        }
        return parseInt(timeStr);
    },

    distance: function(distance) {
        if (Math.abs(distance) < 1000)
            return Math.round(distance) + " m";
        else if (Math.abs(distance) < 100000)
            return Math.round(distance/100)/10 + " km";
        else
            return Math.round(distance/1000) + " km";
    },

    percent: function(ratio) {
        if (typeof ratio != 'number' || isNaN(ratio))
            return undefined;
        return Math.round(ratio*100) + '%';
    },

    parsePercent: function(percent) {
        return parseFloat(percent)/100;
    },

    price: function(price, allow4, decimals) {
        var forceDecimals = decimals && decimals.force ? decimals.force : false;
        if (typeof price == 'undefined') return;
        if (price == null) return null;
        // Price is specified as cents, typically integer, but float (4 decimal prices) supported
        if (!allow4 || Math.abs(Math.round(price) - price) < 1e-3) {
            if (forceDecimals) return parseFloat(price/100).toFixed(2);
            return parseFloat(price/100).toFixed(2).replace(/\.00$/,'');
        } else
            return parseFloat(price/100).toFixed(4);
    },

    hasDecimals: function(items) {
        var decimals = false;
        if (items && items.length && items.length > 0) {
            _(items).some(function (item) {
                if (!item) return true;
                var invoicedAmount = item.invoicedAmount != null ? item.invoicedAmount : item.amount;
                if (!invoicedAmount) return true;
                var price;
                var unitPrice = item.unitPrice ? item.unitPrice : item.articleUnitPrice;
                if (item.unit == 'MONEY' && invoicedAmount != null) price = invoicedAmount;
                else if (unitPrice) price = unitPrice * invoicedAmount / 100;
                else return true;
                if (price % 1 != 0) {
                    decimals = true;
                    return true;
                }
            },this);
        }
        return decimals
    },

    itemRatiosHasDecimals: function(items) {
        if (items && items.length && items.length > 0) {
            return _(items).find(function(item) {
                var totalCost = item.unitCost && item.amount && item.unitCost * item.amount;
                var invoicedAmount = item.invoicedAmount || item.amount;
                var totalPrice = null;
                if (item.unit == 'MONEY' && invoicedAmount != null)
                    totalPrice = invoicedAmount * 100;
                else if (invoicedAmount && item.unitPrice)
                    totalPrice = invoicedAmount * item.unitPrice;
                var margin = totalPrice - totalCost;
                var ratio = Math.round((margin / totalCost) * 1000) / 100;
                return ratio.toString().split('.') && ratio.toString().split('.')[1] && ratio.toString().split('.')[1].length >= 1;
            }, this);
        } else {
            return false;
        }
    },

    parsePrice: function(input) {
        if (typeof input == 'string') input = input.replace(/,/,'.');
        var price = parseFloat((parseFloat(input)*100).toFixed(2));
        if (isNaN(price))
            return null;
        return price;
    },

    parseFloat: function(input) {
        if (typeof input == 'string') input = input.replace(/,/,'.');
        return parseFloat(input);
    },

    bearingAsHalfCardinal: function(bearing) {
        if (0 <= bearing && bearing <= 22.5) {
            return i18next.t('bearingHalfCardinals_0');
        } else if (bearing <= 67.5) {
            return i18next.t('bearingHalfCardinals_1');
        } else if (bearing <= 112.5) {
            return i18next.t('bearingHalfCardinals_2');
        } else if (bearing <= 157.5) {
            return i18next.t('bearingHalfCardinals_3');
        } else if (bearing <= 202.5) {
            return i18next.t('bearingHalfCardinals_4');
        } else if (bearing <= 247.5) {
            return i18next.t('bearingHalfCardinals_5');
        } else if (bearing <= 292.5) {
            return i18next.t('bearingHalfCardinals_6');
        } else if (bearing <= 337.5) {
            return i18next.t('bearingHalfCardinals_7');
        } else if (bearing <= 360) {
            return i18next.t('bearingHalfCardinals_0');
        }
        return null;
    },

    countSuffix: function(count, suffixes) {
        if (count < 10 || count > 20) {
            var str = '' + count;
            var lastDigit = str[str.length - 1];
            switch (lastDigit) {
                case '1':
                    return i18next.t('countSuffixes_0')
                case '2':
                    return i18next.t('countSuffixes_1')
                case '3':
                    return i18next.t('countSuffixes_2')
                default:
                    return i18next.t('countSuffixes_3')
            }
        }
        return i18next.t('countSuffixes_3')
    },

    parseHex: function(value, targetLength){
        var output = value.toString(16);
        while (output.length < targetLength) {
            output = '0' + output;
        }
        return output;
    },

    parseLatLon: function(input) {
        if (!input) return;
        input = input.trim().toLowerCase().replace(/[°'"]/g, ' ');
        var tokens = input.split(/\s*,\s*/);
        if (tokens.length != 2 && input.match(/\d\s*[ns]\s*\d.*[ew]/)) {
            tokens = input.split(/\s*[ns]\s*/);
            tokens[0] += input.match(/[ns]/)[0];
        }
        if (tokens.length != 2) return;
        var ret = [];
        for (var i = 0; i < 2; i++) {
            var value = tokens[i];
            var sign = 1;
            if (value.match(/[sw]/)) sign = -1;
            value = value.replace(/\s*[nsew]\s*/g, '');
            if (!value.match(/,\./) && value.length == 6) {
                value = value.slice(0,2) + " " + value.slice(2,4) + " " + value.slice(4, 6);
            }
            console.log(value);
            var valuetokens = value.split(/\s+/);
            if (valuetokens.length > 3) return;
            if (valuetokens.length == 3) {
                // degrees minutes seconds
                value = parseFloat(valuetokens[0]) + parseFloat(valuetokens[1])/60 + parseFloat(valuetokens[2])/3600;
            } else if (valuetokens.length == 2) {
                // degrees minutes
                value = parseFloat(valuetokens[0]) + parseFloat(valuetokens[1])/60;
            } else
                value = parseFloat(valuetokens[0]);
            if (isNaN(value)) return;
            value *= sign;
            ret.push(value);
        }
        return ret;
    },

    levenshteinDistance: function (s, t) {

        if (s === t) return 0

        var d = []; //2d matrix
    
        // Step 1
        var n = s.length;
        var m = t.length;
    
        if (n == 0) return m;
        if (m == 0) return n;
    
        //Create an array of arrays in javascript (a descending loop is quicker)
        for (var i = n; i >= 0; i--) d[i] = [];
    
        // Step 2
        for (var i = n; i >= 0; i--) d[i][0] = i;
        for (var j = m; j >= 0; j--) d[0][j] = j;
    
        // Step 3
        for (var i = 1; i <= n; i++) {
            var s_i = s.charAt(i - 1);
    
            // Step 4
            for (var j = 1; j <= m; j++) {
    
                //Check the jagged ld total so far
                if (i == j && d[i][j] > 4) return n;
    
                var t_j = t.charAt(j - 1);
                var cost = (s_i == t_j) ? 0 : 1; // Step 5
    
                //Calculate the minimum
                var mi = d[i - 1][j] + 1;
                var b = d[i][j - 1] + 1;
                var c = d[i - 1][j - 1] + cost;
    
                if (b < mi) mi = b;
                if (c < mi) mi = c;
    
                d[i][j] = mi; // Step 6
    
                //Damerau transposition
                if (i > 1 && j > 1 && s_i == t.charAt(j - 2) && s.charAt(i - 2) == t_j) {
                    d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + cost);
                }
            }
        }
    
        // Step 7
        return d[n][m];
    },

    // keys should be an array of properties to sort by, in order of priority
    // note: this routine currently only takes backbone model objects, e.g. objects
    // with the .get() function
    alphaNumericSort: function(items, keys) {
        if (!items) return [];
        if (!keys) return items;
        if (!''.localeCompare || typeof ''.localeCompare != 'function') return items;
        keys = Array.isArray(keys) ? keys : [keys];
        var self = this;
        items.sort(function(a, b) {
            var aKey = self.sortKey(a, keys);
            var bKey = self.sortKey(b, keys);
            if (!aKey && !bKey) return 0;
            if (!bKey) return 1;
            if (!aKey) return -1;
            return a.get(aKey).localeCompare(b.get(bKey), undefined, {
                numeric: true,
                sensitivity: 'accent'
            });
        });
        return items;
    },

    sortKey: function(item, keys) {
        // find first prop in item that contains a value and returns that key
        // to be used in the sorting comparison
        var key = null;
        for (var i = 0; i < keys.length; i++) {
            if (item.get(keys[i])) {
                key = keys[i];
                break;
            }
        }
        return key;
    },
};
